import { render, staticRenderFns } from "./listaAtividades.vue?vue&type=template&id=68558713"
import script from "./listaAtividades.vue?vue&type=script&lang=js"
export * from "./listaAtividades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports